import {
  type PresenceLayerGroupSnapshot,
  type PresenceViewAdapter,
} from '@databases/presence';
import { type ViewProjection } from './create-view-projection.ts';

/**
 * Adapts table placement to the existing presence renderer. The caller owns
 * eligibility, presentation policy, the active controller and renderer lifetime.
 * Empty presence avoids placement reads; unavailable data clears remote boxes.
 */
export function createProjectionPresenceBinding(
  projection: ViewProjection,
  humans: {
    subscribe(listener: VoidFunction): VoidFunction;
    getHumanGroups(): PresenceLayerGroupSnapshot[];
  },
) {
  const adapter: PresenceViewAdapter = {
    getVisibleEntryIds() {
      const snapshot = projection.getSnapshot();
      return snapshot.status === 'ready' ? [...snapshot.entryIds] : [];
    },
    getVisibleFieldIds() {
      const snapshot = projection.getSnapshot();
      return snapshot.status === 'ready' ? [...snapshot.fieldIds] : [];
    },
  };

  return {
    adapter,
    subscribeToPlacementChanges: projection.subscribe,
    presence: {
      subscribe: (listener: VoidFunction) => humans.subscribe(listener),
      getGroups: () => {
        const groups = humans.getHumanGroups();
        return groups.length > 0 && projection.getSnapshot().status === 'ready'
          ? groups
          : [];
      },
    },
  };
}
